import { render, staticRenderFns } from "./StorageAccountDetails.vue?vue&type=template&id=39f3c21a&scoped=true&"
import script from "./StorageAccountDetails.vue?vue&type=script&lang=js&"
export * from "./StorageAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./StorageAccountDetails.vue?vue&type=style&index=0&id=39f3c21a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3c21a",
  null
  
)

export default component.exports